angular.module('app.directives').directive('attachments', () => ({
    restrict: 'E',

    scope: {
        all: '@?',
        model: '@?',
        modelId: '@?',
        addClass: '@?',
        changed: '<?',
    },

    controller($scope, $timeout, $translate, notify, api) {
        $scope.loaded = false;

        $scope.iconClass = (type) => {
            const pairs = (type || '').split('/');

            if ('image' == pairs[0]) {
                return 'fa-file-image-o';
            } else if ('audio' == pairs[0]) {
                return 'fa-file-audio-o';
            } else if ('video' == pairs[0]) {
                return 'fa-file-video-o';
            } else if ('application/pdf' == type) {
                return 'fa-file-pdf-o';
            } else if ('text/plain' == type || 'text/html' == type || 'application/json' == type) {
                return 'fa-file-text-o';
            } else if ('application/gzip' == type || 'application/zip' == type) {
                return 'fa-file-archive-o';
            } else if ('application/octet-stream' == type) {
                return 'fa-file-o';
            }

            return 'fa-file-o';
        };

        $scope.refresh = (clearCache) => {
            const path = `attachments/${$scope.model || ''}/${$scope.modelId || ''}`.replace(/\/+$/, '');
            $scope.loaded = false;

            const model = api(path);

            if (clearCache) {
                model.clearCache();
            }

            model.list().then(
                (response) => {
                    $scope.attachments = response.data;
                    $scope.loaded = true;
                },
                () => {
                    $scope.loaded = true;
                }
            );
        };

        $scope.attachments = [];
        $scope.$watch('modelId', (modelId) => {
            if (0 < modelId && !$scope.loaded) {
                $timeout(() => {
                    $scope.refresh();
                });
            }
        });

        $scope.$watch('changed', (value, old) => {
            if (value != old) {
                $scope.refresh(true);
            }
        });

        $scope.$watch('all', (value, old) => {
            if (value) {
                $scope.refresh(true);
            }
        });

        // czekamy 3s
        $timeout(() => {
            $scope.loaded = true;
        }, 3000);

        $scope.delete = (id) => {
            const info = notify.info($translate.instant('removing'));
            api('attachments')
                .remove(id)
                .then((response) => {
                    if (response.result) {
                        $scope.attachments = _.reject($scope.attachments, { id });
                        notify.success($translate.instant('removed'));
                    }
                });
        };
    },

    templateUrl: '/directives/attachment/attachments.html',
    transclude: false,
}));
